module.exports = __webpack_public_path__ + "static/media/amex.ed4453e2.svg";